import { render, staticRenderFns } from "./VesselsList.vue?vue&type=template&id=4392d824&"
import script from "./VesselsList.vue?vue&type=script&lang=js&"
export * from "./VesselsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports